import { ThemeProvider, createTheme } from '@mui/material/styles';
import React from 'react'
import AppRouter from './router/AppRouter';
import ReactGA from 'react-ga'
import { useEffect } from 'react';

const theme = createTheme({
  palette: {
    primary: {
      light: "#F22E52",
      main: "#39aa28",
      dark: "#408036",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ffffff",
      main: "#B3223C",
      dark: "#cccccc",
      contrastText: "#ff802e",
    },
    default: {
      light: "#ffffff",
      main: "#ffffff",
      dark: "#cccccc",
      contrastText: "#ff802e",

    }
  },
});

const EditorApp = () => {

  useEffect(() => {
    ReactGA.initialize('G-9SZV0BQLT6')
    ReactGA.pageview('/')
  }, [])
  

  return (
    <div>
      <ThemeProvider theme={theme} >
        <AppRouter/>
      </ThemeProvider>
    </div>
  )
}

export default EditorApp;
